import OnlineFootballManagerGames from './online-football-manager-games';
import BeingAFootballManager from './being-a-football-manager';
import EvolutionOfFootballManagerGames from './evolution-of-football-manager-games';
import DiscordFootballManager from './discord-football-manager';
import FreeFootballManagerOnline from './free-football-manager-online';
import PlayFootballManagerOnPhone from './play-football-manager-on-phone';
import FootballManagerWithFriends from './football-manager-with-friends';
import FreeFootballManagerAlternative from './free-football-manager-alternative';
import HattrickAlternative from './hattrick-alternative';
import TopElevenAlternative from './top-eleven-alternative';
import OnlineSoccerManagerAlternative from './online-soccer-manager-alternative';

export const BLOG_ARTICLES = {
  'online-football-manager-games': OnlineFootballManagerGames,
  'being-a-football-manager': BeingAFootballManager,
  'evolution-of-football-manager-games': EvolutionOfFootballManagerGames,
  'discord-football-manager': DiscordFootballManager,
  'free-football-manager-online': FreeFootballManagerOnline,
  'play-football-manager-on-phone': PlayFootballManagerOnPhone,
  'football-manager-with-friends': FootballManagerWithFriends,
  'free-football-manager-alternative': FreeFootballManagerAlternative,
  'hattrick-alternative': HattrickAlternative,
  'top-eleven-alternative': TopElevenAlternative,
  'online-soccer-manager-alternative': OnlineSoccerManagerAlternative,
};

export function getBlogArticle(slug) {
  return BLOG_ARTICLES[slug] || null;
}
